import { ComponentPropsWithoutRef, ElementType, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

type ContainerProps<E extends ElementType> = {
  as?: E;
  children: ReactNode;
  className?: string;
} & Omit<ComponentPropsWithoutRef<E>, 'as' | 'children' | 'className'>;

const Container = <E extends ElementType = 'div'>(props: ContainerProps<E>) => {
  const { as, children, className, ...rest } = props;
  const Element = (as ?? 'div') as ElementType;
  return (
    <Element {...rest} className={twMerge('px-5 sm:px-24', className)}>
      {children}
    </Element>
  );
};

export default Container;
